import React, { useState } from "react";
import { Button, Card, Container, Form, Alert, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { authApi } from "../api/auth";

export default function ForgotPassword() {
  document.body.classList.remove("sidebar-show");

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [validationError, setValidationError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setValidationError(null);
    setSuccess(false);

    // Validation basique
    if (!email.trim()) {
      setValidationError("Veuillez saisir votre adresse email.");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setValidationError("Format d'email invalide.");
      return;
    }

    setLoading(true);
    try {
      // ✅ Appel réel à l'API
      await authApi.requestPasswordReset(email);
      setSuccess(true);
    } catch (err) {
      setError(
        err.response?.data?.error ||
        "Une erreur est survenue. Veuillez réessayer plus tard."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-auth cere-auth">
      {/* En-tête avec logo */}
      <div className="header">
        <Container>
          <Link to="/login" className="header-logo">
            <img
              src="/logo.png"
              alt="CERE Gabon"
              style={{
                height: 56,
                width: "auto",
                objectFit: "contain",
              }}
            />
          </Link>
        </Container>
      </div>

      {/* Contenu */}
      <div className="content">
        <Container>
          <Card className="card-auth cere-auth-card">
            <Card.Body className="text-center">
              {/* Icône */}
              <div className="cere-auth-icon">
                <i className="ri-lock-unlock-line"></i>
              </div>

              <Card.Title className="cere-auth-title">
                Mot de passe oublié
              </Card.Title>
              <Card.Text className="cere-auth-text mb-4">
                Saisissez l'adresse email associée à votre compte.
                Nous vous enverrons un lien pour réinitialiser votre mot de passe.
              </Card.Text>

              {/* Messages */}
              {success && (
                <Alert variant="success" className="cere-auth-alert">
                  <i className="ri-checkbox-circle-line me-2"></i>
                  Un email de réinitialisation a été envoyé à <strong>{email}</strong>.
                  Vérifiez votre boîte de réception.
                </Alert>
              )}
              {error && (
                <Alert variant="danger" className="cere-auth-alert">
                  <i className="ri-error-warning-line me-2"></i>
                  {error}
                </Alert>
              )}

              {/* Formulaire */}
              {!success && (
                <Form onSubmit={handleSubmit} noValidate>
                  <Form.Group className="mb-3 text-start">
                    <Form.Label className="cere-auth-label">
                      Adresse email
                    </Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="vous@exemple.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className={`cere-auth-input ${validationError ? "is-invalid" : ""}`}
                      disabled={loading}
                      autoFocus
                    />
                    {validationError && (
                      <div className="cere-auth-error">{validationError}</div>
                    )}
                  </Form.Group>

                  <Button
                    type="submit"
                    className="cere-btn cere-btn-primary w-100 mb-3"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Envoi en cours…
                      </>
                    ) : (
                      <>
                        <i className="ri-mail-send-line me-2"></i>
                        Envoyer le lien
                      </>
                    )}
                  </Button>
                </Form>
              )}

              {/* Lien retour */}
              <Link to="/login" className="cere-auth-back">
                <i className="ri-arrow-left-line me-1"></i>
                Retour à la connexion
              </Link>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </div>
  );
}